export default __webpack_public_path__ + "a1001a31a0bfe73dca4af61af7159415.png";